import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity SubDivision
 */
@Entity()
export class SubDivision extends Partner {
  static override _class = 'SubDivision';

  @Field(() => String)
  public parentID: Maybe<string>;

  @DataLoadedField(() => Partner, ({ parentID }) => parentID)
  public parent: Maybe<Partner>;

  @Field(() => String)
  public divisionURL: Maybe<string>;

  override get type() {
    return KooperationsPartner.SUB_DIVISON;
  }
}
